document.addEventListener('DOMContentLoaded', function () {

  function initHeaderMove() {
    // console.log("initHeaderMove");
    const topRight = document.querySelector('[data-testid="header-top-right"]');
    const bottomRight = document.querySelector('[data-testid="header-bottom-right"]');

    if (!topRight || !bottomRight) return;

    function moveElements() {
        // console.log("moveElements");
      if (window.innerWidth <= 767) {
        // Move ALL children: bottom → top
        while (bottomRight.firstChild) {
          topRight.appendChild(bottomRight.firstChild);
        }
      } else {
        // Move ALL children: top → bottom
        while (topRight.firstChild) {
          bottomRight.appendChild(topRight.firstChild);
        }
      }
    }

    moveElements(); // Run once
    window.addEventListener('resize', moveElements);
  }

  // ⭐ HALOTHEME: Header sometimes loads later (e.g. sticky, AJAX)
  // → Wait until all dynamic parts are ready
  const checkInterval = setInterval(() => {
    const hasHeader = document.querySelector('.header');
    const topRight = document.querySelector('[data-testid="header-top-right"]');
    const bottomRight = document.querySelector('[data-testid="header-bottom-right"]');

    if (hasHeader && topRight && bottomRight) {
      clearInterval(checkInterval);
      initHeaderMove();
    }
  }, 200);

});